import { TreeNodeListDTO } from 'business/models/Models';
import RMCustomButton from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import React, { useMemo } from 'react';
import { isNullOrUndefined, treeIconColors } from 'utils/Global';
import './CustomBreadCrumbs.scss';
import ReactTooltip from 'react-tooltip';
import BreadCrumbNode from './BreadCrumbNode';
interface CustomBreadCrumbsProps {
  isProteinControl: boolean;
  isScreenControl: boolean;
  treeNodes: TreeNodeListDTO;
  breadCrumbs: any; // TODO: FIx this type
  onBreadCrumbClick?: any;
  hideTreeNodes?: any;
}

export default function CustomBreadCrumbs({
  isProteinControl,
  isScreenControl,
  treeNodes,
  breadCrumbs,
  onBreadCrumbClick,
  hideTreeNodes,
}: CustomBreadCrumbsProps) {
  const getHiddenAndFilteredCrumbsArrays = (breadCrumbsParams) => {
    const hiddenBreadcrumbs = [];
    let index = breadCrumbsParams.length - 2;

    while (index >= 2) {
      const _breadCrumb = breadCrumbsParams[index];
      hiddenBreadcrumbs.push({
        label: _breadCrumb.name,
        Icon: <RMSvgIcon name="Folder" fill="#313131"></RMSvgIcon>,
        onClick: onBreadCrumbClick ? () => onBreadCrumbClick(_breadCrumb) : undefined,
        isDisabled: false,
      });

      breadCrumbsParams.splice(index, 1);
      index = breadCrumbsParams.length - 2;
    }

    return [breadCrumbsParams, hiddenBreadcrumbs];
  };

  const renderCrumbs = useMemo(() => {
    const crumbs = [];
    let hiddenBreadCrumbs = [];
    const shrinkifyBreadCrumbs = breadCrumbs?.length > 3;

    if (shrinkifyBreadCrumbs) {
      [breadCrumbs, hiddenBreadCrumbs] = getHiddenAndFilteredCrumbsArrays([
        ...breadCrumbs,
      ]);
    }

    for (
      let breadCrumbIndex = breadCrumbs?.length - 1;
      breadCrumbIndex >= 0;
      breadCrumbIndex--
    ) {
      if (breadCrumbIndex === breadCrumbs.length - 1) {
        crumbs.push(
          <div
            key={`bread-crumb-item${breadCrumbIndex}`}
            id={`custombreadcrumbs-rendercrumbs-first-${breadCrumbIndex}`}
            data-testid={`custombreadcrumbs-rendercrumbs-first-${breadCrumbIndex}`}
            className={`first-breadCrumb-container ${
              onBreadCrumbClick ? 'cursorPointer' : ''
            }`}
            onClick={
              onBreadCrumbClick
                ? () => onBreadCrumbClick(breadCrumbs[breadCrumbIndex])
                : undefined
            }
          >
            <RMSvgIcon
              id="custombreadcrumbs-rendercrumbs-folderopen-icon"
              data-testid="custombreadcrumbs-rendercrumbs-folderopen-icon"
              name={'FolderOpen'}
              fill={treeIconColors.Folder}
              height={'16px'}
              width={'16px'}
              className={'marginCrumbs'}
            ></RMSvgIcon>
            <BreadCrumbNode
              containerStylesClass={`${onBreadCrumbClick ? 'cursorPointer' : ''}`}
            >
              {breadCrumbs[breadCrumbIndex].name}
            </BreadCrumbNode>
          </div>,
        );
      } else {
        if (shrinkifyBreadCrumbs && crumbs.length === 2) {
          crumbs.push(
            <RMCustomButton
              key={`bread-crumb-hiddenItem${breadCrumbIndex}`}
              id={`bread-crumb-hiddenItem${breadCrumbIndex}`}
              data-testid={`bread-crumb-hiddenItem${breadCrumbIndex}`}
              contentContainerClass="marginCrumbs"
              Icon={
                <div
                  id="custombreadcrumbs-rendercrumbs-transform"
                  data-testid="custombreadcrumbs-rendercrumbs-transform"
                  style={{ transform: 'rotate(90deg)' }}
                >
                  <RMSvgIcon
                    id="custombreadcrumbs-rendercrumbs-transform-threedotmenu-icon"
                    data-testid="custombreadcrumbs-rendercrumbs-transform-threedotmenu-icon"
                    name="ThreeDotMenu"
                    fill={'#313131'}
                    height={'1.4vw'}
                    style={{ maxHeight: '20px' }}
                  />
                </div>
              }
              dropDownList={hiddenBreadCrumbs}
            />,
          );
          crumbs.push(
            <BreadCrumbNode containerStylesClass="overflow-visible">&gt;</BreadCrumbNode>,
          );
        }
        crumbs.push(
          <BreadCrumbNode
            key={`bread-crumb-item${breadCrumbIndex}`}
            containerStylesClass={`${onBreadCrumbClick ? 'cursorPointer' : ''}`}
            onClick={
              onBreadCrumbClick
                ? () => onBreadCrumbClick(breadCrumbs[breadCrumbIndex])
                : undefined
            }
          >
            {breadCrumbs[breadCrumbIndex].name}
          </BreadCrumbNode>,
        );
      }

      if (breadCrumbIndex !== 0) {
        crumbs.push(
          <BreadCrumbNode containerStylesClass="overflow-visible">&gt;</BreadCrumbNode>,
        );
      }
    }

    return crumbs;
  }, [breadCrumbs, onBreadCrumbClick]);

  if (isScreenControl === true || isProteinControl === true) {
    return null;
  }
  if (!hideTreeNodes && (treeNodes === undefined || treeNodes === null)) {
    return null;
  }
  if (isNullOrUndefined(breadCrumbs) || breadCrumbs.length === 0) {
    return null;
  }

  return (
    <div
      id="custombreadcrumbs-breadcrumb-main-container"
      data-testid="custombreadcrumbs-breadcrumb-main-container"
      className="flex flex-row align-center w-full h-full px-4"
    >
      {renderCrumbs}
      <ReactTooltip />
    </div>
  );
}
